/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, type OnInit, PLATFORM_ID } from '@angular/core';
import { StorageEnum } from '../../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountDetail } from '../../shared/models/account-detail';
import { differenceInMonths, format, getDate, getMonth, getYear, startOfMonth } from 'date-fns';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { SidePanelComponent } from '../../shared/components/side-panel/side-panel.component';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { concatMap, map, of } from 'rxjs';
import { RateType } from '../../shared/enums/ratetype.enum';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PlanService } from '../../shared/services/plan.service';
import { PerThermPipe } from '../../shared/pipes/per-therm.pipe';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
import { RouterModule } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';

@Component({
  selector: 'app-plan-details',
  imports: [
    NotificationComponent,
    SidePanelComponent,
    MatCardModule,
    MatExpansionModule,
    MatDividerModule,
    MatTooltipModule,
    MatButtonModule,
    PageHeaderComponent,
    RouterModule,
  ],
  providers: [PerThermPipe],
  templateUrl: './plan-details.component.html',
  styleUrl: './plan-details.component.scss',
})
export class PlanDetailsComponent implements OnInit {
  isBrowser: boolean;
  notification: string = '';
  accountDetail: AccountDetail;
  loginResponse: any;
  pageReady = false;
  showExpirationDate: boolean = true;
  showCtaButtons: boolean = true;
  sidePanelData: any;
  fullAddress = '';
  pageName = 'Plan Details';
  pageLabels: any = {};
  pageData: any = {};
  headerData = new PageHeader();
  oppTag: string = '';

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly utils: UtilService,
    private readonly storage: StorageService,
    private readonly notifi: NotificationsService,
    private readonly cms: CmsService,
    private readonly plan: PlanService,
    private readonly perThermPipe: PerThermPipe,
    private readonly seoS: SeoService,
    private readonly acct: AccountService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    this.loginResponse = this.storage.getSession(StorageEnum.LoginResponse);
    this.plan.setPerThermPipe(this.perThermPipe);
  }

  ngOnInit(): void {
    this.getPageLabels()
      .pipe(
        concatMap((pageLabels) => {
          if (!this.utils.isNullOrUndefined(pageLabels)) {
            this.pageLabels = pageLabels;
            this.headerData.Message = this.pageLabels.planDetailsHeadlineText;
          }
          if (this.utils.rateChangeOrUpdate()) {
            return this.acct.getAccountDetail(this.accountDetail.AccountNumber, this.loginResponse.UserName);
          } else {
            return of('use account detail from storage');
          }
        }),
      )
      .subscribe((data: any) => {
        if (data !== 'use account detail from storage') {
          this.accountDetail = data;
        }
        if (this.isBrowser) {
          if (!this.utils.isNullOrUndefined(this.accountDetail) && !this.utils.isNullOrUndefined(this.pageLabels)) {
            if (this.utils.isNullOrUndefined(this.storage.getSession(StorageEnum.SelectedSA))) {
              this.storage.setSession(StorageEnum.SelectedSA, this.accountDetail.ServiceAddresses[0]);
            }
            this.oppTag = this.storage.getSession(StorageEnum.GlobalVars).oppTag;
            this.setPageData();
            this.setSidePanelData(this.pageLabels.sidePanelData);
            this.pageReady = true;
            this.createNotification(this.pageLabels);
            this.utils.hideSpinner();
          }
        }
      });
  }

  getPageLabels(): any {
    return this.cms.getContent('oas-plan-details', this.pageName).pipe(
      map((data: any) => {
        if (!this.utils.isNullOrUndefined(data)) {
          this.seoS.setSeoTags(data.seo);
          return data;
        }
      }),
    );
  }

  setPageData(): void {
    // Address
    if (!this.utils.isNullOrUndefined(this.accountDetail.ServiceAddresses)) {
      const address1 = this.accountDetail.ServiceAddresses?.[0].Address1;
      const address2 = this.accountDetail.ServiceAddresses?.[0].Address2;

      if (!this.utils.isNullOrUndefined(address1)) {
        if (!this.utils.isNullOrUndefined(address2)) {
          this.pageData.fullAddress =
            '<i class="fa-thin fa-location-dot"></i> ' + (address1! + address2!).toUpperCase();
        } else {
          this.pageData.fullAddress = '<i class="fa-thin fa-location-dot"></i> ' + address1?.toUpperCase();
        }
      }
    }

    // Expiration Data & Tool Tip Data
    if (this.accountDetail.BillingRateExpirationDate && this.showExpirationDate) {
      this.pageData.expirationDate = format(
        this.accountDetail.BillingRateExpirationDate.toString().replaceAll('-', '/'),
        'MM/dd/yyyy',
      );
      this.pageData.toolTipOpp = this.pageLabels.expirationDateToolTipText;
      this.pageData.toolTipRenew = this.pageLabels.renewPlanToolTip.replaceAll(
        '{{expirationDate}}',
        this.pageData.expirationDate,
      );
    }

    // Side Panel Data
    this.sidePanelData = this.pageLabels.sidePanelData;

    // Current Plan Data
    if (this.accountDetail.SaRateScheduleCode && this.accountDetail.CustomerClass) {
      this.pageData.plan = this.plan.getAllPlanData(
        this.accountDetail.SaRateScheduleCode,
        this.accountDetail.CustomerClass,
        this.accountDetail.BillRate?.Rate,
        this.accountDetail.BillRate?.Type,
      );
    }
    this.setDataToDisplay();

    // Rate Change Link
    this.pageData.rateChangeURL = this.pageLabels.rateChangeLink.value.data.url;
    this.pageData.rateChangeAriaLabel = 'To go and change your rate';

    // Renew Link
    this.pageData.renewLinkURL = this.pageLabels.renewPlanLink.value.data.url;
    this.pageData.renewLinkAriaLabel = this.pageLabels.renewPlanLink.value.data.ariaLabel;
    this.pageData.renewLinkText = this.pageLabels.renewPlanLink.value.data.linkText.replaceAll('Rate', 'Plan');

    // Stop Service Link
    this.pageData.stopServiceURL = this.pageLabels.stopServiceLink.value.data.url;
    this.pageData.stopServiceAriaLabel = this.pageLabels.stopServiceLink.value.data.ariaLabel;

    // Start Service Link
    this.pageData.startServiceURL = this.pageLabels.startServiceLink.value.data.url;
    this.pageData.startServiceAriaLabel = this.pageLabels.startServiceLink.value.data.ariaLabel;

    // Move Service Link
    this.pageData.moveServiceURL = this.pageLabels.moveServiceLink.value.data.url;
    this.pageData.moveServiceAriaLabel = this.pageLabels.moveServiceLink.value.data.ariaLabel;
    // view all plans link
    this.pageData.viewPlansLabel = 'View Plans';
    this.pageData.viewPlansAriaLabel = 'Go to View All Plans';
    this.pageData.viewPlansURL = this.pageLabels.viewAllPlansLink.value.data.url;
  }

  createNotification(data: any): void {
    if (
      !this.utils.isNullOrUndefined(this.accountDetail) &&
      !this.utils.isNullOrUndefined(this.accountDetail.BillRate)
    ) {
      if (
        (this.accountDetail.CustomerClass === 'RES' || this.accountDetail.CustomerClass === 'SMLCOM') &&
        this.accountDetail.LandLordAlertIndicator !== 'Y'
      ) {
        if (
          this.accountDetail.SaRateScheduleCode?.includes('FIX') ||
          this.accountDetail.SaRateScheduleCode?.includes('FX') ||
          this.accountDetail.SaRateScheduleCode?.includes('FLT') ||
          this.accountDetail.SaRateScheduleCode?.includes('NMX') ||
          this.accountDetail.SaRateScheduleCode?.includes('MEX')
        ) {
          if (this.accountDetail.ServiceAddresses) {
            if (this.accountDetail.ServiceAddresses[0].SARenewalIndicator === 'Y') {
              if (this.accountDetail.HeadlineCode !== '25' && this.accountDetail.HeadlineCode !== '30') {
                this.notification = data.prenotificationEligibleToRenew;
              } else {
                this.notification = '';
              }
            } else if (this.checkIsOneMonthPrior(this.accountDetail)) {
              this.notification = data.prenotificationWithinThirtyDayPeriod.replace(
                '{{newDate}}',
                this.getNewFirstDay(this.accountDetail),
              );
            } else if (
              this.accountDetail.BillRate?.Type !== RateType.Variable &&
              this.accountDetail.BillRate?.Type !== RateType.Undefined
            ) {
              this.notification = this.pageLabels.renewPlanToolTip.replaceAll(
                '{{expirationDate}}',
                format(this.pageData.expirationDate, 'MMMM yyyy'),
              );
            }
          }
        } else if (this.accountDetail.SaRateScheduleCode?.includes('VAR')) {
          this.notification = data.prenotificationVariableRate;
        }
      } else if (this.accountDetail.LandLordAlertIndicator === 'Y') {
        this.notification = data.prenotificationCallForAssistance;
      } else {
        this.notification = data.prenotificationCallForAssistance;
      }
    }
    if (this.notification !== '') {
      this.notifi.addNotification(this.notification, NotificationType.Prenotification, this.pageName);
    }
  }

  checkIsOneMonthPrior(accountDetail: AccountDetail): boolean {
    const BillingRateExpirationDate = accountDetail.BillingRateExpirationDate;
    const date = new Date();
    const currentDate = getYear(date) + '-' + (getMonth(date) + 1) + '-' + getDate(date);
    let withinOneMonth: number;
    let showMessage: boolean = false;
    if (!this.utils.isNullOrUndefined(BillingRateExpirationDate) && !this.utils.isNullOrUndefined(currentDate)) {
      withinOneMonth = differenceInMonths(BillingRateExpirationDate!, currentDate);
      if (withinOneMonth <= 1) {
        showMessage = true;
      } else {
        showMessage = false;
      }
    }
    return showMessage;
  }

  getNewFirstDay(accountDetail: AccountDetail): string {
    const BillingRateExpirationDate = accountDetail.BillingRateExpirationDate;
    let newFirstDay: string = '';

    if (!this.utils.isNullOrUndefined(BillingRateExpirationDate)) {
      newFirstDay = format(startOfMonth(BillingRateExpirationDate!), 'MMMM do, yyyy');
    }

    return newFirstDay;
  }

  setSidePanelData(panelArray: any[]): void {
    let currentState = '';
    if (
      (this.accountDetail.CustomerClass === 'RES' || this.accountDetail.CustomerClass === 'SMLCOM') &&
      this.accountDetail.ServiceAddresses[0].SaStatusFlag === '20' &&
      this.accountDetail.LandLordAlertIndicator !== 'Y'
    ) {
      if (this.accountDetail.SaRateScheduleCode) {
        if (this.accountDetail.SaRateScheduleCode.includes('VAR')) {
          currentState = 'RESandSMLCOM - Variable';
        } else if (
          this.accountDetail.SaRateScheduleCode.includes('FLT') ||
          this.accountDetail.SaRateScheduleCode.includes('FIX') ||
          this.accountDetail.SaRateScheduleCode.includes('FX') ||
          this.accountDetail.SaRateScheduleCode.includes('NMX') ||
          this.accountDetail.SaRateScheduleCode.includes('MEX')
        ) {
          if (
            this.accountDetail.ServiceAddresses &&
            this.accountDetail.ServiceAddresses[0].SARenewalIndicator !== 'N'
          ) {
            if (this.accountDetail.HeadlineCode !== '25' && this.accountDetail.HeadlineCode !== '30') {
              currentState = 'RESandSMLCOM - Renewal State';
            } else {
              currentState = 'Default';
            }
          } else {
            if (this.checkIsOneMonthPrior(this.accountDetail)) {
              currentState = 'RESandSMLCOM - Not in Renewal State - 30 days prior';
            } else {
              currentState = 'RESandSMLCOM - Not in Renewal State - not 30 days prior';
            }
          }
        }
      }
    } else if (this.accountDetail.CustomerClass === 'LRGCOM') {
      currentState = 'LRGCOM';
    } else if (this.accountDetail.LandLordAlertIndicator === 'Y') {
      currentState = 'LRGCOM';
    } else {
      currentState = 'Default';
    }
    this.sidePanelData = panelArray.find((panel) => {
      return panel.currentState === currentState;
    }).panelData.value.data;
  }

  setDataToDisplay(): void {
    if (
      this.accountDetail.BillRate?.Type === RateType.Variable ||
      this.accountDetail.BillRate?.Type === RateType.Undefined
    ) {
      this.showExpirationDate = false;
      this.showCtaButtons = false;
      if (this.pageData.plan.planType !== 'Variable Rate' && this.pageData.plan.planType !== 'Complex') {
        this.pageData.plan.planType = this.pageData.plan.planType + ' Rate';
      }
    } else {
      if (this.accountDetail.BillingRateExpirationDate) {
        this.showExpirationDate = true;
      } else {
        this.showExpirationDate = false;
      }
      this.showCtaButtons = true;
      if (this.pageData.plan.planType !== 'Fixed' && this.pageData.plan.planType !== 'Complex') {
        if (this.pageData.plan.planType === 'OnePrice Plan') {
          this.pageData.plan.planType = this.pageData.plan.planType + this.oppTag;
        } else {
          this.pageData.plan.planType = this.pageData.plan.planType + ' Rate';
        }
      } else {
        this.pageData.plan.planType = this.pageData.plan.planType + ' Rate';
      }
    }
  }
}
